const HostAndDomain = (props) => {
  const domain = props?.row?.original?.domain || "-";

  return <span title={domain}>{domain}</span>;
};

export default HostAndDomain;
